export default __webpack_public_path__ + "static/media/icon-tick.4121404b.gif";